import useLayout from "@/lib/layout/useLayout";
import { Tabs, Tab } from "@heroui/react";
import {
    createFileRoute,
    Link,
    Outlet,
    useMatch,
} from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/dashboard/account-settings")({
    component: RouteComponent,
});

function RouteComponent() {
    const { setLayoutState } = useLayout();
    useEffect(() => {
        setLayoutState("full_screen");
    }, [setLayoutState]);

    const accountTab = useMatch({
        from: "/dashboard/account-settings/account",
        shouldThrow: false,
    });

    const productsTab = useMatch({
        from: "/dashboard/account-settings/products",
        shouldThrow: false,
    });

    const connectionsTab = useMatch({
        from: "/dashboard/account-settings/connections",
        shouldThrow: false,
    });

    const notificationsTab = useMatch({
        from: "/dashboard/account-settings/notifications",
        shouldThrow: false,
    });

    const tab = [accountTab, productsTab, connectionsTab, notificationsTab]
        ?.find((x) => !!x)
        ?.fullPath?.split("/")
        .pop();

    return (
        <div className="p-2 flex flex-col h-full">
            <Tabs
                radius="sm"
                className="px-1 pb-1"
                selectedKey={tab}
                color="secondary"
                variant="underlined"
            >
                <Tab
                    title="Account"
                    key="account"
                    as={Link}
                    // @ts-expect-error ts(2322 )
                    to="/dashboard/account-settings/account"
                />
                <Tab
                    title="Products"
                    key="products"
                    as={Link}
                    // @ts-expect-error ts(2322 )
                    to="/dashboard/account-settings/products"
                />
                <Tab
                    title="Connections"
                    key="connections"
                    as={Link}
                    // @ts-expect-error ts(2322 )
                    to="/dashboard/account-settings/connections"
                />
                <Tab
                    title="Notifications"
                    key="notifications"
                    as={Link}
                    // @ts-expect-error ts(2322 )
                    to="/dashboard/account-settings/notifications"
                />
            </Tabs>
            <Outlet />
        </div>
    );
}
